import { z } from 'zod'
import { requiredString } from '../primitives'

// Forma REAL (shared/schemas/place.ts): department/municipality son CÓDIGOS numéricos.
export const PlaceSchema = z.object({
  country: requiredString(),
  department: z.number().int().positive().optional(),
  municipality: z.number().int().positive().optional()
})

export type Place = z.infer<typeof PlaceSchema>
